import { get } from 'svelte/store';
import { user } from '../stores';
import { getInteractionContext } from './interactionContext.js';

let lastDedup = '';
let lastTime = 0;

function serializeContext(context) {
    try {
        return JSON.stringify(context);
    } catch (_) {
        return '';
    }
}

export function setError(messageOrObj) {
    const payload = typeof messageOrObj === 'string'
        ? { message: messageOrObj }
        : messageOrObj;

    const now = Date.now();
    const dedup = `${payload.message}|${payload.source || ''}|${payload.endpoint || ''}`;
    if (dedup === lastDedup && now - lastTime < 500) return;
    lastDedup = dedup;
    lastTime = now;

    const userEmail = get(user)?.Email || '';

    const userCtx = typeof payload.context === 'string'
        ? { note: payload.context }
        : (payload.context || {});
    const contextStr = serializeContext({ ...getInteractionContext(), ...userCtx });

    try {
        navigator.sendBeacon(
            `${import.meta.env.VITE_API_BASE_URL}/frontend-errors`,
            new Blob([JSON.stringify({
                message: String(payload.message || '').slice(0, 2000),
                stack: String(payload.stack || '').slice(0, 10000),
                source: payload.source || 'unknown',
                pageUrl: location.href,
                userEmail,
                statusCode: payload.statusCode || 0,
                endpoint: payload.endpoint || '',
                context: contextStr.slice(0, 4000),
            })], { type: 'application/json' })
        );
    } catch (_) {}
}
